import SessionDesk from "@/pages/Dashboard";

// /candidates is the Session desk scrolled to the ranked candidate blotter.
export default function Candidates() {
  return <SessionDesk focus="candidates" />;
}
